module.exports = __webpack_public_path__ + "img/J12149.84098f1f.png";